import React, { useState, useCallback, useMemo } from "react";
import { Accordion, Container, Col } from "react-bootstrap";

const FAQ = () => {
  const [activeKey, setActiveKey] = useState(null);

  const icons = useMemo(
    () => ({
      plus: "/assets/Plus.svg",
      minus: "/assets/Minus.svg",
    }),
    []
  );

  const faqs = useMemo(
    () => [
      {
        question: "Do you offer a free trial?",
        answer:
          "Yes, Nouraa AI provides a free trial so you can experience our 24/7 AI-powered answering service before committing.",
      },
      {
        question: "How much does Nouraa AI cost?",
        answer:
          "Pricing varies based on your needs. Contact us for a personalized quote.",
      },
      {
        question: "Can I get help setting up Nouraa AI?",
        answer:
          "Absolutely! Our team is here to assist you with the setup process to ensure a smooth experience.",
      },
      {
        question: "Can I keep my existing phone number?",
        answer:
          "Yes, you can integrate Nouraa AI with your current phone number.",
      },
      {
        question: "How long does it take to set up?",
        answer: "Setup is quick and easy, usually taking less than a day.",
      },
      {
        question: "Can Nouraa AI handle after-hours and overflow calls?",
        answer:
          "Yes, Nouraa AI ensures you never miss a call by handling inquiries 24/7, including after-hours and overflow calls.",
      },
      {
        question:
          "Does Nouraa AI stay updated on my business information, like hours?",
        answer:
          "Yes, Nouraa AI continuously updates itself with your business information, ensuring accurate responses.",
      },
    ],
    []
  );

  const toggleFAQ = useCallback((key) => {
    setActiveKey((prevKey) => (prevKey === key ? null : key));
  }, []);

  return (
    <Container className=" empty-space-mt mb-5 faq">
      <h2 className="text-center fs-four-title anybody-font fw-bold mb-4">
        Frequently Asked Questions
      </h2>
      <p className="text-center fs-two gray-color mb-5">
        Get your questions answered
      </p>
      <Col lg={9} className="mx-auto pb-5">
        <Accordion activeKey={activeKey}>
          {faqs.map((faq, index) => (
            <Accordion.Item
              eventKey={index.toString()}
              key={index}
              className="border-0"
            >
              <Accordion.Header onClick={() => toggleFAQ(index.toString())}>
                <div className="d-flex justify-content-between w-100">
                  <span className="fw-bold fs-three">{faq.question}</span>
                  <img
                    src={
                      activeKey === index.toString() ? icons.minus : icons.plus
                    }
                    alt={activeKey === index.toString() ? "Close" : "Open"}
                    className="ms-2"
                  />
                </div>
              </Accordion.Header>
              <Accordion.Body className="fs-one px-0">
                {faq.answer}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Col>
    </Container>
  );
};

export default FAQ;
